var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { margin: "40px" } }, [
    _c(
      "div",
      [
        _c("h1", [_vm._v("Print test")]),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: `Space Height ${_vm.space_height * 0.125}mm` },
          model: {
            value: _vm.space_height,
            callback: function ($$v) {
              _vm.space_height = _vm._n($$v)
            },
            expression: "space_height",
          },
        }),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: "Max bits" },
          model: {
            value: _vm.max_bits,
            callback: function ($$v) {
              _vm.max_bits = _vm._n($$v)
            },
            expression: "max_bits",
          },
        }),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: "Width" },
          model: {
            value: _vm.width,
            callback: function ($$v) {
              _vm.width = _vm._n($$v)
            },
            expression: "width",
          },
        }),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: "Height" },
          model: {
            value: _vm.height,
            callback: function ($$v) {
              _vm.height = _vm._n($$v)
            },
            expression: "height",
          },
        }),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: "QR Width" },
          model: {
            value: _vm.qr_width,
            callback: function ($$v) {
              _vm.qr_width = _vm._n($$v)
            },
            expression: "qr_width",
          },
        }),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: "QR Space" },
          model: {
            value: _vm.qr_space,
            callback: function ($$v) {
              _vm.qr_space = _vm._n($$v)
            },
            expression: "qr_space",
          },
        }),
        _c("v-text-field", {
          directives: [{ name: "only-number", rawName: "v-only-number" }],
          attrs: { label: "Font Size" },
          model: {
            value: _vm.font_size,
            callback: function ($$v) {
              _vm.font_size = _vm._n($$v)
            },
            expression: "font_size",
          },
        }),
        _c("v-text-field", {
          attrs: { label: "Data" },
          model: {
            value: _vm.data_array,
            callback: function ($$v) {
              _vm.data_array = $$v
            },
            expression: "data_array",
          },
        }),
        _c(
          "v-btn",
          {
            staticStyle: { "margin-right": "10px" },
            attrs: { dark: "" },
            on: { click: _vm.onPrint },
          },
          [_vm._v("Print")]
        ),
        _c("v-btn", { attrs: { dark: "" }, on: { click: _vm.onPaint } }, [
          _vm._v("Paint"),
        ]),
        _c("div", { staticClass: "mb-2" }),
        !_vm.print_text
          ? _c(
              "v-btn",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: { width: "168", dark: "" },
                on: {
                  click: function ($event) {
                    _vm.print_text = true
                  },
                },
              },
              [_vm._v("Print Text ")]
            )
          : _c(
              "v-btn",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: { width: "168", dark: "" },
                on: {
                  click: function ($event) {
                    _vm.print_text = false
                  },
                },
              },
              [_vm._v("Print Image")]
            ),
      ],
      1
    ),
    _c("div", { staticStyle: { "margin-top": "10px" } }, [
      _c("canvas", { ref: "can", staticStyle: { border: "1px solid black" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }